import React, {useEffect, useReducer} from 'react';

import {useProducerCtx} from '@/views/Layout/b2b/ProducerNavBar/state';
import reducer, {getInitialState} from '@/b2b/pages/NewBusiness/state';
import {NewBusinessCtx} from '@/b2b/contexts';

import SearchBox from '@/b2b/pages/NewBusiness/SearchBox';
import PolicyList from '@/b2b/pages/NewBusiness/PolicyList';
import {LegendList, SortLabelHint} from '@/b2b/components/LegendList';

const NewBusinessContext = ({children}) => {
  const [producer] = useProducerCtx();
  const [state, dispatch] = useReducer(reducer, getInitialState(producer));

  useEffect(
    () => {
      dispatch({
        type: 'changeProducer',
        payload: {
          manager: producer.producerFullName,
          selectedProducerId: producer.producerId,
        },
      });
    },
    [producer]
  );

  return (
    <NewBusinessCtx.Provider value={[state, dispatch]}>
      {children}
    </NewBusinessCtx.Provider>
  );
};

const NewBusiness = () => (
  <NewBusinessContext>
    <SearchBox />
    <SortLabelHint />
    <PolicyList />
    <LegendList />
  </NewBusinessContext>
);

export default NewBusiness;
